import { RootState } from 'store';
import managersAdapter from 'store/adapters/company-managers-adapter';

export const managersSelectors = managersAdapter.getSelectors((state: RootState) => state.managers);
export const managersSelector = managersSelectors.selectAll;
export const managersErrorSelector = (state: RootState): boolean => state.managers.managersError;

export const managersLoadingSelector = (state: RootState): boolean => state.managers.loading;
